export default __webpack_public_path__ + "static/media/ARPHICPL.c09ff3fc.TXT";